export default __webpack_public_path__ + "static/media/buddy-header.54b37c65.jpg";